import { useEffect, useRef, useState } from "react";
import { Coffee, Play } from "lucide-react";
import { C } from "../../lib/api";
import { sounds } from "../../lib/sounds";

const mmss = (ms) => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

// Sit out for up to SIT_OUT_MAX_MS (3 min). Mid-hand it takes effect at hand end; the seat is released when time runs out.
export const SitOutButton = ({ my, serverNow, send }) => {
  const out = my.status === C.SeatStatus.SITTING_OUT && my.sit_out_until && my.stack > 0; // busted seats show RE-BUY? instead
  const [left, setLeft] = useState(0);
  const lastBeep = useRef(null);
  useEffect(() => {
    if (!out) return;
    const id = setInterval(() => {
      const l = my.sit_out_until - serverNow();
      setLeft(l);
      if (l > 0 && l <= C.TDA.SIT_OUT_WARN_MS) { // last 10 s: one beep per second, sharper for the final three
        const sec = Math.ceil(l / 1000);
        if (lastBeep.current !== sec) { lastBeep.current = sec; sounds.beep(sec <= 3); }
      }
    }, 250);
    return () => clearInterval(id);
  }, [out, my.sit_out_until, serverNow]);
  if (out) {
    return (
      <button data-testid="sit-in-button" onClick={() => send(C.WsClientEvent.SIT_IN)}
        className="rounded-full px-3 py-1 text-xs bg-amber-500 text-slate-900 btn-lift flex items-center gap-1 font-semibold">
        <Play className="w-3 h-3" /> I'm back <span className="font-mono" data-testid="sit-out-countdown">{mmss(left)}</span>
      </button>
    );
  }
  if (my.sit_out_pending) {
    return (
      <button data-testid="sit-out-cancel-button" onClick={() => send(C.WsClientEvent.SIT_IN)}
        className="rounded-full px-3 py-1 text-xs bg-white/10 text-amber-200 btn-lift flex items-center gap-1" title="Click to stay in">
        <Coffee className="w-3 h-3" /> Sitting out after this hand
      </button>
    );
  }
  if (my.status !== C.SeatStatus.ACTIVE) return null;
  return (
    <button data-testid="sit-out-button" onClick={() => send(C.WsClientEvent.SIT_OUT)}
      className="rounded-full px-3 py-1 text-xs bg-white/5 hover:bg-amber-500/30 btn-lift flex items-center gap-1" title="Take a break (up to 3 minutes)">
      <Coffee className="w-3 h-3" /> Sit out
    </button>
  );
};
